export const WIZARD_PT_BR = {
	common: {
		pointsOfSale: "Pontos de venda",
		saved: "Salvar",
		cancel: "Cancelar",
		typeHere: "Digite aqui",
		close: "Fechar",
	},
	welcome: {
		title: "Boas vindas, <placeName>{{placeName}}</placeName>!",
		subtitle: "Escolha como deseja configurar sua operação.",
		skipButton: "Não quero configurar agora",
		placeIdNotFound: "Place ID não encontrado",
		features: {
			preConfiguredSteps: "Etapas com sugestões pré-configuradas",
			guidedStepsWithAI: "Passo a passo guiado com ajuda de IA",
			advancedConfigurations: "Configurações avançadas e personalizações",
			complexFeatures: "Funcionalidades mais complexas",
		},
		guidedMode: {
			title: "Criação guiada (modo simplificado)",
			subtitle: "A gente guia você passo a passo",
			buttonText: "Acessar modo simplificado",
			features: {
				basicConfigurations: "Configurações mais básicas",
				idealForSimpleOperations: "Ideal para operações mais simples e menores",
			},
		},
		advancedMode: {
			title: "Criação avançada",
			subtitle: "Mais opções e detalhes de configurações",
			buttonText: "Acessar modo avançado",
			features: {
				directConfiguration: "Configuração direta nos módulos do Dashboard",
				idealForComplexOperations: "Ideal para operações grandes e complexas",
			},
		},
	},
	container: {
		stepIndexTitle: "Configure seu local",
		buttons: {
			back: "Voltar",
			close: "Fechar",
			next: "Avançar",
			configureLater: "Configurar depois",
			finishConfiguration: "Concluir configurações",
			backToStep: "Voltar para a Etapa {{step}}",
		},
		finishConfirmation: {
			title: "Concluir configurações da operação",
			descriptionPart1: "Você está prestes a concluir a configuração desta operação.",
			descriptionPart2:
				"Um resumo final será gerado e ficará disponível para consulta a qualquer momento. Depois, você poderá revisar e editar quando precisar.",
			cancelButton: "Cancelar",
			confirmButton: "Concluir configurações",
			successMessage: "Configurações salvas com sucesso!",
			continueToNextStep: {
				title: "Concluir e seguir para a próxima etapa",
				descriptionPart1: "Você está prestes a concluir esta etapa.",
				descriptionPart2:
					"Ao continuar, as configurações serão salvas e você seguirá para a próxima etapa.",
				confirmButton: "Salvar e avançar",
			},
		},
		closeModalConfirmation: {
			title: "Sair da configuração sem salvar?",
			description:
				"Ao fechar agora, as informações configuradas até aqui não serão salvas e você perderá o progresso. Deseja continuar?",
			cancelButton: "Continuar configurando",
			confirmButton: "Sair sem salvar",
			fromSecondStep: {
				title: "Sair da configuração simplificada?",
				descriptionIntro:
					"Este assistente ajuda a configurar sua operação de forma simplificada. Se você sair agora:",
				bullet1: "Você não poderá retornar para continuar a configuração por aqui",
				bullet2: "As informações desta etapa serão descartadas",
				bullet3: "As etapas já concluídas permanecerão salvas",
				descriptionOutro:
					"Ao sair agora, as próximas configurações deverão ser feitas diretamente nas telas avançadas do Dashboard.",
				cancelButton: "Continuar configurando",
				confirmButton: "Sair da configuração simplificada",
			},
		},
		steps: {
			basicInformation: {
				title: "Informações básicas",
				subtitle: "Configure o tipo da operação",
				operationType: {
					title: "Como os clientes irão <highlight>comprar</highlight>?",
					subtitle: "Escolha um ou mais formatos que se aplicarão á esta operação.",
					alert: {
						message: "Estas opções já vem marcadas do contrato da sua operação.",
						description: "Você pode manter como está ou ajustar, se desejar.",
					},
					subStepTitle: "Tipo de operação",
				},
				functionalities: {
					title: "Quais serão as <highlight>funcionalidades</highlight> desta operação?",
					subtitle:
						"As funcionalidades são opções com recursos que permitem configurar a operação de forma personalizada.",
					subStepTitle: "Funcionalidades",
					searchFunctionalities: "Buscar por funcionalidades",
					placeholderSearchFunctionalities: "Digite aqui a funcionalidade",
					activeLabel: "ativas",
					loadingText: "Carregando funcionalidades...",
					emptySearchResults: "Nenhuma funcionalidade encontrada",
				},
				review: {
					title:
						"Já conseguimos entender as <highlight>configurações iniciais</highlight> da operação!",
					subtitle: "De acordo com as suas respostas, o sistema irá configurar:",
					subStepTitle: "Revisão",
					reviewTitle: "Revise as respostas",
					reviewSubtitle: "Você poderá editá-las agora, antes de concluir a etapa.",
					editStep: "Editar etapa",
					operationTypeLabel: "Tipo de operação",
					functionalitiesLabel: "Funcionalidades",
					notInformed: "Não informado",
					selectedCount: "{{count}} selecionada(s)",
					viewFunctionalities: "Ver funcionalidades",
				},
			},
			pointsOfSale: {
				pdvCentralName: "Ponto de venda central",
				title: "Pontos de venda",
				subtitle: "Configure os locais de venda",
				pointsOfSale: {
					subStepTitle: "Pontos de venda",
					title: "Quais serão os <highlight>pontos de venda</highlight> desta operação?",
					subtitle:
						"Nomeie apenas os pontos de venda que serão os locais onde ficarão as maquininhas Zig.",
					createButton: "Criar ponto de venda",
					defaultPdvName: "Novo ponto de venda",
					totalCount: "Total de pontos de venda: <strong> {{count}} </strong>",
					aiTutorial: "Saiba como usar a IA para criar os pontos de venda",
					emptyTitle: "Ainda não há pontos de venda por aqui",
					emptySubtitle: "Crie seu primeiro ponto de venda para começar.",

					tour: {
						step1: {
							title:
								"Ponto de venda é o local onde acontecem as vendas da sua operação através das maquininhas Zig.",
							content:
								"Se sua operação tiver apenas 1 (um) ponto de venda, basta avançar. Se precisar editar ou criar novos pontos, você pode fazer isso agora.",
						},
						step2: {
							title: "Você pode criar os pontos de venda com ajuda da IA",
							content:
								"Caso queira utilizar a IA, basta descrever os nomes e quantidades desejadas, e serão gerados automaticamente.",
						},
						step3: {
							title:
								"Quer revisar algo? Use o menu lateral para voltar às etapas já concluídas.",
							content:
								"Basta clicar em uma etapa concluída para revisar as configurações e volte para a etapa atual para continuar de onde parou.",
						},
					},
					aiTutorialModal: {
						step1: {
							title: "Clique no <highlight>Assistente de IA</highlight>",
							description:
								"Abra o Assistente para iniciar a criação automática dos seus pontos de venda.",
						},
						step2: {
							title:
								"Descreva os nomes e quantidades dos <highlight>pontos de venda</highlight>",
							description:
								"Informe quais os nomes e as quantidades dos locais onde irão acontecer as vendas com as maquininhas Zig na operação. (Ex.: 1 Bar Principal, 2 Pistas premium, 1 Área Cozinha)",
							note: "Capriche nas descrições!",
						},
						step3: {
							title: "Confirme e <highlight>gere os pontos de venda</highlight>",
							description:
								"Revise o resumo que a IA te mostrar e clique em 'Gerar pontos de venda' para criar automaticamente.",
						},
						buttons: {
							understand: "Entendi",
						},
					},
					aiAssistant: {
						panelTitle: "Assistente de IA da Zig",
						triggerBubbleTitle: "Sou seu Assistente de IA da Zig.",
						triggerBubbleSubtitle: "Te ajudo a criar os pontos de venda",
						inputPlaceholder: "Descreva os pontos de venda ou pergunte algo",
						generateButton: "Gerar pontos de venda",
						initialMessage:
							"👋 Olá! Sou seu Assistente de IA.\nEstou aqui para ajudar você a criar os pontos de venda da sua operação.\n\n📋 Basta me dizer quais você precisa (nomes e quantidades).\nEu reviso tudo com você e, com sua confirmação, gero tudo automaticamente.\n\n💬 Vamos começar? Quais pontos de venda deseja criar?",
						summaryIntro: "Perfeito! Aqui está o resumo do que você informou:",
						summaryConfirmation:
							"Se estiver tudo certo, basta clicar abaixo para gerar os pontos de venda.",
						loadingMessage: "Criando...",
						successMessage:
							"🎉 Tudo certo! Os pontos de venda foram criados com sucesso!",
						successFollowUp:
							"Se quiser adicionar novos pontos de venda, basta me enviar novamente os nomes e quantidades que deseja criar.",
						onlyCreateError:
							"😅 Desculpe, mas aqui eu só consigo criar novos pontos de venda. Se precisar editar ou remover algum existente, você pode fazer isso diretamente na tela.",
					},
				},
				sectors: {
					subStepTitle: "Setores",
					title: "Deseja organizar os pontos de venda em <highlight>setores</highlight>?",
					subtitle:
						"Defina se prefere estruturar seus pontos de venda em setores ou manter cada um separado.",
					options: {
						withoutSectors: {
							title: "Manter os pontos de venda avulsos (sem setores)",
							subtitle:
								"Os pontos de venda ficarão independentes, sem agrupamento por setor.",
						},
						withSectors: {
							title: "Organizar os pontos de venda por setores",
							subtitle:
								"Os pontos de venda serão agrupados dentro dos setores que você definir.",
						},
					},
					placeholder: {
						message: "Funcionalidade de setores será implementada em breve",
					},
					creation: {
						title: "Agrupe todos os pontos de venda em setores",
						subtitle: "Todos os pontos de venda deverão pertencer a algum setor.",
						createButton: "Criar novo Setor",
						emptyTitle: "Ainda não tem nada por aqui",
						emptySubtitle: "Agrupe pontos de venda em setores",
						unlinkedCount: "{{count}} Pontos de venda a serem agrupados",
						tour: {
							title: "Crie o primeiro setor",
							content:
								"Clique no botão 'Criar novo setor' para começar a organizar seus pontos de venda.",
							understood: "Entendi",
						},
						deleteConfirmTitle: "Excluir setor?",
						deleteConfirmSubtitle:
							"Este setor será removido. Os pontos de venda poderão ser vinculados a outro setor.",
					},
					creationDrawer: {
						createTitle: "Criar novo Setor",
						editTitle: "Editar Setor",
						nameLabel: "Nome",
						namePlaceholder: "Digite o nome do setor",
						nameRequired: "Campo obrigatório",
						pointsOfSaleLabel: "Pontos de venda do Setor",
						pointsOfSalePlaceholder: "Selecione os pontos de venda",
						pointsOfSaleRequired: "Campo obrigatório",
						createButton: "Criar novo Setor",
						saveButton: "Salvar",
					},
				},
				review: {
					subStepTitle: "Revisão",
					title:
						"Etapa 2 concluída! <highlight>Pontos de vendas</highlight> configurados!",
					subtitle:
						"Os pontos de venda que você criou estão prontos para vender produtos e funcionários.",
					reviewTitle: "Revise as respostas",
					reviewSubtitle: "Você poderá editá-las agora ou no final do fluxo.",
					reviewAlertTitle: "Revise esta etapa com calma.",
					reviewAlert:
						"Ao avançar, estas configurações não poderão mais ser editadas por aqui e só poderão ser ajustadas diretamente nos módulos do Dashboard.",
					editStep: "Editar",
					editPointsOfSale: "Pontos de venda",
					editSectors: "Setores",
					pointsOfSaleLabel: "Pontos de venda",
					notInformed: "Não informado",
				},
				pdvCreateNewPdvDrawer: {
					title: "Este nome de ponto de venda já existe!",
					subtitle:
						"Já existe um ponto de venda com este nome. Para continuar, escolha um nome diferente para evitar duplicidade.",
					newPdvDrawerTitle: "Nome do ponto de venda",
					createButton: "Criar ponto de venda",
					nameRequired: "O nome do ponto de venda é obrigatório",
				},
			},
			menu: {
				title: "Cardápio",
				subtitle: "Configure os produtos",
				organization: {
					title:
						"As <highlight>vendas serão diferentes</highlight> de acordo com o ponto de venda?",
					subtitle:
						"Defina se o pontos de venda irão compartilhar os mesmos produtos e preços ou se haverá diferenças entre eles.",
					subStepTitle: "Organização",
					yes: {
						title: "SIM",
						subtitle: "Cada ponto de venda terá seus próprios produtos e preços.",
						example:
							"Exemplo: Cada ponto de venda tem vendas próprias com produtos diferentes.",
					},
					no: {
						title: "NÃO",
						subtitle:
							"Todos os pontos de venda terão os mesmos produtos e os mesmos preços.",
						example:
							"Exemplo: Em qualquer ponto de venda as opções de produtos são idênticas.",
					},
					changeFormatModal: {
						title: "Deseja alterar o formato de venda dos pontos de venda?",
						description:
							"Você está alterando a forma como os produtos são vendidos entre os pontos de venda. Essa alteração pode impactar as configurações atuais e poderá precisar de ajustes conforme a nova escolha. Deseja continuar assim mesmo?",
						cancelButton: "Cancelar",
						confirmButton: "Sim, alterar formato de venda",
					},
				},
				buildMenus: {
					title: "Criar <highlight>cardápio</highlight>",
					subtitle: "Importe produtos com fotos, planilhas ou PDFs.",
					subStepTitle: "Montar cardápio",
					templateFileName: "planilha_modelo_produtos_menu",
					buttons: {
						templateSpreadsheet: "Planilha modelo",
						createCategory: "Criar categoria",
						addManually: "Adicionar manualmente",
					},
					tour: {
						locale: {
							back: "Voltar",
							next: "Próximo",
							close: "Entendi",
						},
						steps: {
							upload: {
								title: "Comece enviando um arquivo com os produtos.",
								content:
									"Você pode adicionar uma foto, planilha ou PDF com os produtos que deseja incluir neste cardápio. A IA vai ler o arquivo e cadastrar automaticamente os itens para você.",
							},
							manual: {
								title: "Ou, se preferir, adicione os produtos manualmente.",
								content:
									"Se desejar, você pode criar categorias e adicionar produtos manualmente sem usar um arquivo.",
							},
						},
					},
					addProductDrawer: {
						title: "Adicionar produto",
						titleEdit: "Editar produto",
						labels: {
							name: "Nome do produto",
							value: "Valor",
							category: "Categoria do produto",
						},
						placeholders: {
							name: "Digite aqui o nome do produto",
							value: "00,00",
							category: "Selecione",
						},
						errors: {
							nameRequired: "O nome do produto é obrigatório",
							nameDuplicated: "Já existe um produto com este nome",
							valueRequired: "O valor do produto é obrigatório",
							categoryRequired: "A categoria é obrigatória",
						},
						buttons: {
							cancel: "Cancelar",
							add: "Adicionar produto",
							save: "Salvar",
						},
						createCategoryOption: "Criar categoria",
					},
					createCategoryModal: {
						title: "Criar categoria",
						label: "Nome da categoria",
						placeholder: "Digite aqui o nome da categoria",
						errors: {
							nameRequired: "O nome da categoria é obrigatório",
							nameDuplicated: "Já existe uma categoria com este nome",
						},
						buttons: {
							cancel: "Cancelar",
							create: "Criar categoria",
						},
					},
					removeCategory: {
						title: "Remover categoria",
						description:
							"Ao remover esta categoria, todos os produtos vinculados a ela também serão removidos. Deseja continuar?",
						confirmButton: "Remover categoria",
					},
					removeProduct: {
						title: "Remover produto",
						description:
							"Este produto será excluído do cardápio e não poderá mais ser vendido nos pontos de venda. Deseja confirmar a remoção?",
						confirmButton: "Remover produto",
					},
				},
				linkProducts: {
					title: "Vincule os <highlight>produtos</highlight> aos pontos de venda",
					subtitle:
						"Os cardápios e produtos serão vendidos no ponto de venda em que serão vinculados",
					subStepTitle: "Vincular produtos",
					noProductsLinked: "Não há produtos vinculados!",
					productsCount: "{{count}} produtos",
					productsCount_one: "{{count}} produto",
					linkProductsButton: "Vincular produtos",
					viewProductsLink: "Ver produtos",
					incompleteModal: {
						title: "Alguns pontos de venda estão incompletos",
						description:
							"Alguns pontos de venda estão sem cardápios e produtos vinculados. Você pode vincular agora ou continuar e editar depois.",
						continueButton: "Continuar e editar depois",
						editButton: "Editar agora",
					},
					tour: {
						locale: {
							close: "Entendi",
						},
						step: {
							title: "Defina o que cada ponto de venda irá vender.",
							content:
								"Selecione os cardápios que esse ponto terá. Você também pode desativar/ativar produtos específicos, deixando apenas o que será vendido nele.",
						},
					},
					drawer: {
						editTitle: "Selecione cardápios para este ponto de venda",
						editSubtitle:
							"Os produtos desses cardápios serão vinculados a este ponto. Você poderá desativar produtos específicos, se desejar.",
						viewTitle: "Produtos vinculados",
						viewSubtitle:
							"Revise os produtos deste ponto de venda e edite os vínculos, se desejar.",
						selectAllLabel: "Selecionar todos os produtos de {{categoryName}}",
						labels: {
							menus: "Cardápios",
							searchProduct: "Buscar por produto",
							searchCategory: "Buscar por categoria do produto",
						},
						placeholders: {
							menus: "Selecione",
						},
						buttons: {
							cancel: "Cancelar",
							link: "Vincular produtos",
							edit: "Editar",
							close: "Fechar",
						},
						empty: {
							title: "Ainda não tem nada por aqui",
							subtitle: "Vincule quais serão os cardápios deste ponto de venda.",
						},
						noResultsFound: {
							title: "Nenhum resultado encontrado",
							subtitle: "Tente buscar por outro termo.",
						},
					},
				},
				review: {
					title: "Revise as <highlight>configurações do cardápio</highlight>",
					subtitle: "Confira se todas as informações estão corretas antes de continuar.",
					subStepTitle: "Revisão",
					pendingTitle: "Etapa 3: <highlight>configurações pendentes</highlight>",
					pendingSubtitle: "Você decidiu configurar esta etapa depois.",
					reviewTitle: "Revise as respostas",
					reviewSubtitle: "Você poderá editá-las agora, antes de concluir a etapa.",
					editStep: "Editar etapa",
				},
			},
			employees: {
				title: "Funcionários",
				subtitle: "Configure a equipe da operação",
				rolesAndPermissions: {
					title:
						"Quem vai trabalhar utilizando as <highlight>maquininhas de ficha</highlight> na operação?",
					subtitle:
						"Defina quais serão os cargos e quantidades de quem vai vender as fichas com as maquininhas na operação.",
					subStepTitle: "Cargos e permissões",
					header: "Cargos e permissões",
					totalEmployees: "Total de funcionários:",
					createRole: "Criar novo cargo",
					roleDrawer: {
						title: "Criar cargo",
						roleNameLabel: "Nome do cargo",
						selectStandardRole: "Selecione um cargo padrão já existente",
						selectStandardRolePlaceholder: "Selecione um cargo",
						defaultPermissionsTab: "Permissões padrão",
						otherPermissionsTab: "Outras permissões",
						createButton: "Criar cargo",
						duplicateNameError: "Já existe um cargo com esse nome",
						editTitle: "Editar cargo",
						duplicateTitle: "Duplicar cargo",
						viewTitle: "Ver permissões",
						editRoleButton: "Editar cargo",
						confirmButton: "Confirmar",
						searchPermissionsPlaceholder: "Buscar por permissão",
						confirmClose: {
							title: "Descartar alterações?",
							subtitle:
								"Você tem alterações não salvas. Tem certeza que deseja fechar sem salvar?",
							confirm: "Descartar",
							cancel: "Continuar editando",
						},
					},
					confirmDelete: {
						title: "Remover cargo com funcionários vinculados",
						subtitle:
							"Este cargo possui {{count}} funcionário(s) vinculado(s). Deseja remover assim mesmo?",
						confirm: "Remover cargo",
						cancel: "Cancelar",
					},
					tour: {
						locale: {
							back: "Voltar",
							next: "Próximo",
							close: "Entendi",
						},
						step1: {
							title: "Esses cargos são sugestões para sua operação.",
							content:
								"Você pode editar ou remover, se desejar. Se não quiser que um cargo exista na operação, remova-o. Do contrário, ele será criado mesmo que a quantidade esteja zerada.",
						},
						step2: {
							title: "Defina quantas pessoas terão em cada cargo",
							content:
								"Use o contador para indicar quantas pessoas vão atuar em cada função. Apenas os cargos com quantidade definida terão logins gerados automaticamente.",
						},
						step3: {
							title: "Crie cargos personalizados",
							content:
								"Se precisar de um cargo diferente dos sugeridos, clique em Criar novo cargo para adicionar funções específicas e definir permissões personalizadas.",
						},
					},
				},
				linkEmployees: {
					title: "Vincular funcionários",
					subtitle: "Associe os funcionários a cada ponto de venda.",
					subStepTitle: "Vincular funcionários",
					tour: {
						locale: {
							back: "Voltar",
							next: "Próximo",
							close: "Entendi",
						},
						step1: {
							title: "Vincule os funcionários aos pontos de venda",
							content:
								"Os funcionários precisam estar vinculados aos pontos de venda para usar as maquininhas e registrar as vendas. Você pode definir se todos de um mesmo cargo vão atuar nos mesmos pontos de venda ou se quer distribuir individualmente.",
						},
						step2: {
							title: "Distribua manualmente, se preferir",
							content:
								"Ative a opção Distribuir manualmente para definir onde cada funcionário vai atuar. Assim, você pode escolher em quais pontos de venda cada funcionário terá acesso e visualizar isso de forma individual.",
						},
					},
				},
				review: {
					title: "<highlight>Funcionários e cargos</highlight> configurados!",
					subtitle: "Os funcionários e cargos da operação já estão configurados.",
					subStepTitle: "Revisão",
					pendingTitle: "Etapa 4: <highlight>configurações pendentes</highlight>",
					pendingSubtitle: "Você decidiu configurar essa etapa depois.",
					reviewTitle: "Revise suas respostas",
					reviewSubtitle: "Você pode editá-las agora, antes de concluir a etapa.",
					editStep: "Editar etapa",
					reviewAlertTitle: "Revise esta etapa com calma.",
					reviewAlert:
						"Ao avançar, estas configurações não poderão mais ser editadas por aqui e só poderão ser ajustadas diretamente nos módulos do Dashboard.",
					notConfigured: "Etapa não configurada",
					pendingEmptySubtitle:
						"Você ainda não configurou os funcionários desta operação.",
				},
			},
		},
		operationTypes: {
			token: {
				label: "Ficha",
				description: "Cliente troca ficha por produto",
			},
			cashlessPrepaid: {
				label: "Cashless (pré-pago)",
				description: "Cliente carrega crédito num cartão",
			},
			cashlessPostpaid: {
				label: "Cashless (pós-pago)",
				description: "Cliente paga num cartão após o consumo",
			},
			directSale: {
				label: "Venda direta no bar",
				description: "Cliente paga pelo produto diretamente",
			},
			tables: {
				label: "Mesas",
				description: "Cliente realiza o pedido para os garçons",
			},
		},
		summary: {
			title: "Resumo da configuração do <placeName>{{placeName}}</placeName>!",
			subtitle:
				"Edite respostas, volte etapas ou acesse configurações avançadas a qualquer momento.",
			editStep: "Editar etapa",
			operationType: "Tipo de operação",
			functionalities: "Funcionalidades",
			viewFunctionalities: "Ver funcionalidades",
			advancedConfigurations: "Configurações avançadas de Funcionalidades",
			notInformed: "Não informado",
			selectedCount: "{{count}} selecionada(s)",
			pendingAction: "Ação pendente",
			loading: "Carregando configurações...",
			placeIdNotFound: "Place ID não encontrado",
			errorLoading: "Erro ao carregar dados",
			menuContent: {
				manageLink: "Configurações avançadas de Cardápio",
				empty: {
					title: "Ainda não tem nada por aqui",
					subTitle: "Configure esta etapa para ver o resumo aqui.",
				},
				advancedConfig: "Configuração avançada",
			},
			employeesContent: {
				manageLink: "Configurações avançadas de Equipes e Cargos",
			},
			stepEmpty: {
				title: "Ainda não tem nada por aqui",
				subTitle:
					"O assistente de configuração não está mais disponível, mas você pode concluir essa configuração pelo Dashboard.",
				buttonLabel: "Configuração avançada",
			},
		},
	},
	components: {
		pdvCard: {
			menu: {
				edit: "Editar",
				remove: "Remover",
				ariaLabel: "Menu de opções",
			},
			buttons: {
				cancel: "Cancelar",
				save: "Salvar",
			},
		},
		productCard: {
			menu: {
				edit: "Editar",
				remove: "Remover",
				ariaLabel: "Menu de opções",
			},
		},
		positionCard: {
			menu: {
				viewPermissions: "Ver permissões",
				edit: "Editar",
				duplicate: "Duplicar",
				remove: "Remover",
				ariaLabel: "Menu de opções",
			},
			decrementLabel: "Diminuir quantidade",
			incrementLabel: "Aumentar quantidade",
		},
		menuCard: {
			productsCount: "{{count}} produtos",
		},
		empty: {
			title: "Ainda não tem nada por aqui",
			description: "Parece que você ainda não tem nada por aqui.",
			button: "Adicionar novo item",
		},
		attachmentsFile: {
			loadingText: "Aguarde enquanto enviamos o arquivo...",
			dragText: "Arraste e solte o arquivo",
			clickText: "ou clique para selecionar",
			fileTypeText: "Tipo de arquivo {{fileType}} até {{fileSize}}.",
			maxSizeExceeded: "O tamanho do arquivo excede o limite permitido.",
		},
		modalSelectImage: {
			productImage: "Editar imagem",
			setTagInput: "Procure pelo produto usando palavras-chave",
			confirm: "Confirmar",
			notInformed: "Nome não informado",
			selectFrom: "Selecione imagem do seu ",
			computer: "computador",
			addImage: "Adicionar imagem",
			typeOfFile: "Tipo de arquivo .jpg, .jpeg, .png até 5MB",
			errorCreatingImageUrl: "Erro ao criar URL da imagem",
		},
		employeePdvLink: {
			manualDistribution: "Distribuir manualmente",
			description:
				"Escolha para quais pontos de venda todos os <strong>{{count}} {{roleName}}</strong> irão trabalhar",
			selectedCount: "{{count}} Selecionados",
			selectPointsOfSale: "Selecione os pontos de venda",
			noEmployees: "Nenhum funcionário criado para este cargo.",
			noEmployeesMessage:
				"Defina a quantidade de pessoas neste cargo para habilitar a distribuição por ponto de venda.",
		},
		employeeRoleTable: {
			columnOperator: "OPERADOR",
			columnLogin: "LOGIN",
			columnPassword: "SENHA",
			columnPdv: "PONTOS DE VENDA VINCULADOS",
			linkedTo: "Vinculados à",
			employeesCount: "{{count}} funcionários",
			viewPermissions: "Ver permissões",
			notInformed: "Não informado",
			noEmployees: "Não possui funcionários ainda",
		},
		menuHeader: {
			linkedTo: "Vinculado á:",
			noLinkedPdv: "Nenhum ponto de venda vinculado",
			noLinkedMenu: "Nenhum cardápio vinculado",
			notConfigured: "Não configurado",
			productsCount: "{{count}} PRODUTOS",
		},
	},
};
export type WizardTranslations = typeof WIZARD_PT_BR;
